import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SureFlowUnitData} from '../../model/sure-flow-unit-data';
import {SelectionSystemType} from '../../model/selection-system-type';
import {UnitSelectionService} from '../../services/unit-selection-service';
import {StringUtils} from '../../utils/string-utils';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';
import {MatButton} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {MatInput} from '@angular/material/input';
import {MatFormField, MatLabel} from '@angular/material/form-field';


@Component({
    selector: 'app-add-non-sure-flow-unit-dialog',
    templateUrl: './add-non-sure-flow-unit-dialog.component.html',
    styleUrls: ['./add-non-sure-flow-unit-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatButton]
})
export class AddNonSureFlowUnitDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<AddNonSureFlowUnitDialogComponent>>(MatDialogRef);
  private readonly unitSelectionService = inject(UnitSelectionService);
  private readonly data = inject(MAT_DIALOG_DATA);


  readonly unitData: SureFlowUnitData;
  isBusy!: boolean;
  readonly errorMessage = signal<string>(undefined!);
  private readonly systemType = signal<SelectionSystemType>(undefined!);
  private readonly isMetric: boolean;
  private readonly systemTypeCode: string;
  readonly showTagInput: boolean;

  constructor() {
    this.systemTypeCode = this.data.systemTypeCode;
    this.isMetric = this.data.isMetric || false;
    this.unitData = this.data.unitData || new SureFlowUnitData();
    this.showTagInput = this.data.showTagInput;
  }

  ngOnInit(): void {
    this.unitSelectionService.getSureFlowSystemTypes().subscribe({
      next: (systemTypes) => {
        this.systemType.set(systemTypes.filter(st => st.code === this.systemTypeCode)[0]);
      }, error: (error) => this.handleError(error)
    });
  }

  private handleError(error: any) {
    this.isBusy = false;
    this.errorMessage.set(StringUtils.formatErrorMessage(error));
  }

  cancel(): void {
    this.dialogRef.close();
  }

  hasCooling(): boolean {
    return StringUtils.equalsIgnoreCase('C', this.systemType()?.primaryCoilApplication);
  }

  hasHeating(): boolean {
    return StringUtils.equalsIgnoreCase('H', this.systemType()?.primaryCoilApplication)
      || StringUtils.equalsIgnoreCase('H', this.systemType()?.secondaryCoilApplication);
  }

  isValid(): boolean {
    if (this.hasCooling()) {
      if (this.unitData.coolingFluidFlowRate <= 0) {
        return false;
      }
      if (this.unitData.coolingTargetTotalLoad <= 0) {
        return false;
      }
    }
    if (this.hasHeating()) {
      if (this.unitData.heatingFluidFlowRate <= 0) {
        return false;
      }
      if (this.unitData.heatingTargetTotalLoad <= 0) {
        return false;
      }
    }
    return true;
  }

  save(): void {
    if (this.isValid()) {
      this.dialogRef.close(this.unitData);
    }
  }

  getCapacityUnits(): string {
    return UnitConversionUtils.getCapacityUnits(this.isMetric);
  }

  getFlowRateUnits(): string {
    return UnitConversionUtils.getFlowRateUnits(this.isMetric);
  }

}
